/**
 * Motifs visuais eBuz - Plus + Grid + Ecosystem diagram
 *
 * Plus motif: cross sign rosa, ícone-assinatura (vide Manual seção 02-Logo)
 * Grid bg: linhas 32x32 sutis, DNA visual (sempre presente em backgrounds gerados)
 */

import type { CSSProperties } from 'react'

interface PlusMotifProps {
  size?: number
  color?: string
  className?: string
  style?: CSSProperties
}

/**
 * Plus motif (cross sign) - assinatura visual eBuz.
 * Use em eyebrows, antes de metadata, em pontos onde quer marcar "elemento eBuz".
 *
 * @example
 * <Eyebrow><PlusMotif /> Manual de identidade</Eyebrow>
 */
export function PlusMotif({
  size = 14,
  color = 'var(--brand-pink-1)',
  className = '',
  style,
}: PlusMotifProps) {
  return (
    <span
      className={className}
      style={{
        position: 'relative',
        width: size,
        height: size,
        flexShrink: 0,
        display: 'inline-block',
        ...style,
      }}
      aria-hidden="true"
    >
      <span
        style={{
          position: 'absolute',
          left: '50%',
          top: 0,
          width: 1.5,
          height: '100%',
          background: color,
          transform: 'translateX(-50%)',
        }}
      />
      <span
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          height: 1.5,
          width: '100%',
          background: color,
          transform: 'translateY(-50%)',
        }}
      />
    </span>
  )
}

interface GridBgProps {
  children?: React.ReactNode
  className?: string
  pink?: boolean
  style?: CSSProperties
}

/**
 * Grid bg motif - 32x32 lines sutis (DNA visual eBuz).
 *
 * @example
 * <GridBg className="aspect-square p-8">
 *   <img src="/brand/logo-light.png" />
 * </GridBg>
 */
export function GridBg({ children, className = '', pink = false, style }: GridBgProps) {
  const cls = pink ? 'grid-bg-pink' : 'grid-bg'
  return (
    <div className={`${cls} ${className}`} style={style}>
      {children}
    </div>
  )
}

interface GradientTextProps {
  children: React.ReactNode
  as?: 'span' | 'h1' | 'h2' | 'h3' | 'div' | 'b' | 'strong'
  className?: string
}

/**
 * Gradient text - aplica brand-grad em texto.
 * Use com parcimônia (apenas em palavras-chave de hero/CTAs).
 *
 * @example
 * <h1>Da intuição ao <GradientText>ecossistema</GradientText>.</h1>
 */
export function GradientText({ children, as = 'span', className = '' }: GradientTextProps) {
  const Tag = as
  return (
    <Tag className={`gradient-text ${className}`}>
      {children}
    </Tag>
  )
}
